import React from 'react';
import PropTypes from 'prop-types';
import { HighlightTile } from 'web-ui-components/lib/molecules/tile';
import { IndicativeHighlight } from 'web-ui-components/lib/typography/highlights';

export const RatesImportantInfoSection = ({ title, description, extraInfo }) => (
	<HighlightTile type="info">
		<div>
			<span className="u-color-utility-note">
				<IndicativeHighlight.description>
					<b>*{title}</b>
				</IndicativeHighlight.description>
			</span>
			<p>{description}</p>
			<p>{extraInfo}</p>
		</div>
	</HighlightTile>
);

RatesImportantInfoSection.propTypes = {
	title: PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
	extraInfo: PropTypes.string.isRequired,
};
export default RatesImportantInfoSection;
